import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row header mx-0" }
const _hoisted_2 = { class: "col header-inner" }
const _hoisted_3 = {
  key: 0,
  class: "login-state"
}
const _hoisted_4 = { class: "row content-row mx-0" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "router-view-wrap" }
const _hoisted_7 = { class: "footer row justify-content-center mx-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LoadingOverlay = _resolveComponent("LoadingOverlay")!
  const _component_AuthUpdateOverlay = _resolveComponent("AuthUpdateOverlay")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["container-fluid px-0", {'height-100vh': _ctx.authUpdateOverlayStateStore.state.show}]),
      style: _normalizeStyle({ fontSize: _ctx.FontSizes.normal})
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["app-title", {'app-title-clickable': _ctx.canClickAppTitle()}]),
            style: _normalizeStyle({fontSize: _ctx.FontSizes.large2}),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickAppTitle && _ctx.onClickAppTitle(...args)))
          }, "アト前払いシステム", 6),
          (_ctx.authStore.getters.existsToken)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(_ctx.authStore.state.auth.name) + "さんがログイン中 ", 1),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClickLogout && _ctx.onClickLogout(...args)), ["prevent","stop"]))
                }, "ログアウト")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_view),
            _createVNode(_component_LoadingOverlay)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col text-center" }, "Ⓒ 株式会社アト 2022", -1)),
        (_ctx.authStore.getters.existsToken)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-outline-light change-pw-button",
              style: _normalizeStyle({fontSize: _ctx.FontSizes.small1}),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickChangePassword && _ctx.onClickChangePassword(...args)))
            }, "認証情報の変更", 4))
          : _createCommentVNode("", true)
      ])
    ], 6),
    _createVNode(_component_AuthUpdateOverlay),
    _createVNode(_component_ConfirmDialog),
    _createVNode(_component_Toast)
  ], 64))
}